import React, {useEffect, useState} from 'react';
import OutletsDropdown from '../Components/Dropdowns/OutletsDropdown';
import ReadinessContent from '../Components/ReadinessContent';
import Page from '../Components/Page';
import {Breadcrumbs} from '../Components/Breadcrumbs';
import PeriodsDropdown from '../Components/Dropdowns/PeriodsDropdown';
import {makeApolloClientCall} from '../../Api/makeApolloApiCall';
import {ReadinessApiError} from '../Components/ReadinessApiError';
import LoadingSpinner from "../Components/LoadingSpinner";
import {makeApiCall} from "../../Api/makeApiCall";

export const ALL_OTHER_RETAILERS = 'All Other Retailers (No outlet assigned)';

const OUTLET_DROPDOWN_ADDITIONAL_OPTIONS = [{value: -100, label: ALL_OTHER_RETAILERS, outletName: ALL_OTHER_RETAILERS}];

const Readiness = () => {

    const [outletSelection, setOutletSelection] = useState("SPINS PET");
    const [periodSelection, setPeriodSelection] = useState(undefined);
    const [sampleMarketsOnly, setSampleMarketsOnly] = useState(false);
    const [activeRetailersOnly, setActiveRetailersOnly] = useState(true);
    const [data, setData] = useState(undefined);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(undefined);
    const [alertData, setAlertData] = useState(undefined);
    const [alertIsLoading, setAlertIsLoading] = useState(false);

    const getDefaultPeriod = () => {
        const graphqlQuery = `query { getNextPeriodIfExists { periodAbbreviation } }`
        makeApolloClientCall(graphqlQuery)
            .then((results) => {
                setPeriodSelection(results.getNextPeriodIfExists.periodAbbreviation)
            });
    }

    const handleSubmit = () => {
        setLoading(true);
        setData(undefined);
        getAlerts()
        makeApolloClientCall(getQuery())
            .then((result) => {
                setLoading(false);
                setData(result);
            })
            .catch((e) => {
                setLoading(false);
                setError(e);
            })
    }

    const getAlerts = () => {
        makeApiCall(`${process.env.REACT_APP_EDP_API_BASE_URL}/opsAlertLogsCountByRetailer/`)
            .then(alertData => {
                setAlertIsLoading(false);
                setAlertData(alertData);
            })
    }

    const getQuery = () => {
        const outlets = outletSelection !== ALL_OTHER_RETAILERS ? `["${outletSelection}"]` : '[null]';
        const period = periodSelection ? `, periodAbbreviation:"${periodSelection}"` : '';
        const geographyComposition = sampleMarketsOnly ? ', geographyComposition: "sample"' : ''
        return ` query {
                      periodReleaseReadiness(outlets:${outlets}${period}${geographyComposition}) {
                        periodAbbreviation
                        periodWeeks {endDate}
                        accounts {
                          retailer {retailerId retailChain}
                          isKeyAccount
                          isNonMarketRetailer
                          isRetailerActive
                          issues {issueType week {endDate} count message days}
                          weeksWithSales {weeksWithData totalExpectedWeeks}
                          allOutlets
                        }
                      }
                }`;
    }

    useEffect(() => {
        getDefaultPeriod();
    }, []);

    return (<Page name={'Period Release Readiness'}
                  breadCrumbs={<Breadcrumbs items={[{label: 'Market Insights'}, {label: 'Readiness'}]}/>}>
        <div className={'readiness-options'}>
            <PeriodsDropdown
                id={"periods"}
                updatePeriod={(value) => setPeriodSelection(value)}
                selectedPeriod={periodSelection}
                graphqlQuery={'{ marketPeriodList }'}
            />
            <OutletsDropdown
                onChange={(option) => setOutletSelection(option && option.outletName)}
                value={outletSelection}
                additionalOptions={OUTLET_DROPDOWN_ADDITIONAL_OPTIONS}
            />
            <div id={'check-boxes'}>
                <div className="checkbox-container">
                    <input className={'checkbox'} type="checkbox" id={'sample-markets-only'}
                           data-testid={'sample-markets-only'}
                           checked={sampleMarketsOnly}
                           onChange={() => setSampleMarketsOnly(!sampleMarketsOnly)}
                    />
                    <label className={'checkbox-label'} htmlFor={'sample-markets-only'}>Sample Markets Only</label>
                </div>
                <div className="checkbox-container">
                    <input className={'checkbox'} type="checkbox" id={'active-retailers-only'}
                           data-testid={'active-retailers-only'}
                           checked={activeRetailersOnly}
                           onChange={() => setActiveRetailersOnly(!activeRetailersOnly)}
                    />
                    <label className={'checkbox-label'} htmlFor={'active-retailers-only'}>Active Retailers Only</label>
                </div>
            </div>
            <div>
                <button className={'button primary left-margin'} onClick={() => handleSubmit()}>Submit</button>
            </div>
        </div>
        {loading && <LoadingSpinner/>}
        {data && <ReadinessContent data={data}
                                   activeRetailersOnly={activeRetailersOnly}
                                   outlet={outletSelection}
                                   alertData={alertData}
                                   alertIsLoading={alertIsLoading}/>}
        {error && <ReadinessApiError errorMessage={JSON.stringify(error)}/>}
    </Page>);
}

export default Readiness;